// extracted by mini-css-extract-plugin
export default {"container":"counter_container__8lFQb","margin":"counter_margin__-kckj"};